import React, { useRef } from "react";
import { message } from "antd";
import { useStoreModel } from "../storeModel";
import { IYhFormRef, FormItemTypeEnum, IYhForm, ISelectOption } from "../../../../../components/YhFormBox/Types";
import { useDictModel } from "../../dict/dictModel";
import { getFormValidatorErrText } from "../../../../../utils/utils";
import { YHDrawer } from "../../../../../components/YhDrawer";
import { YhForm } from "../../../../../components/YhFormBox";
import { useOrganizationModel } from "../../org/organizationModel";
import { useGlobalModel } from "../../../../../model/globalModel";
import { useUserModel } from "@src/views/authPortal/auth/user/userModel";
import { TreeDsType } from "@src/components/YhPageHeader/Types";
import { debounce } from "lodash";

export function DetailDrawer() {
    const { orgDs, beDs, shopTypeDs, shopDrawer: { visible, mode }, setIShopDrawer, insertShop, editShop, getSelectedRowData } = useStoreModel();
    const formRef = useRef<IYhFormRef>();
    const {
        roleDs,
        searchParam,
        userTypeDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useUserModel();
    const onCancel = () => {
        setIShopDrawer();
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: any) => {
            console.log(val)
            let data = {
                ...val,
                status: val.status ? 0 : 1,
                type: val.type ? 0 : 1,
                details: val.details?.map((item: any) => ({
                    shopCode: "",
                    bentityCode: item,
                    bentityName: beDs?.find((origin: any) => origin.value === item)?.label ?? ""
                }))
            }
            mode === "edit" ? editShop(data) : insertShop(data);
        }).catch(err => {
            // console.log(err)
            message.warning(getFormValidatorErrText(err));
        })
    }

    //机构选中
    const onTreeSelectChange = (value: string, node: any) => {
        console.log(node)
        node && formRef.current?.setFieldsValue({ orgName: node.title });
    }

    //门店类型
    const categoryChang = (value: string, option: ISelectOption) => {
        option && formRef.current?.setFieldsValue({ categoryName: option.label });
    }

    const formConfig: IYhForm<any> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "edit" ? getSelectedRowData() : { status: true, branch: "vrm", type: false },
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "分支编码",
                fieldName: "branch",
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "门店编码",
                fieldName: "code",
                placeholder: "自动生成",
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店名称",
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入门店名称" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "从属机构",
                fieldName: "orgCode",
                onTreeSelectChange,
                treeDs: orgDs,
                span: 24,
                rules: [{ required: true, message: "请选择从属机构" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "门店类型",
                onSelectChange: categoryChang,
                fieldName: "categoryCode",
                ds: shopTypeDs,
                // rules: [{ required: true, message: "请输入门店类型" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "关联实体",
                fieldName: "details",
                colClassName: "ant-col-h-auto",
                mode: "multiple",
                ds: beDs,
                rules: [{ required: true, message: "请输入关联实体" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "负责人",
                fieldName: "contact",
                span: 24,
                rules: [{ required: true, message: "请输入负责人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "公司地址",
                fieldName: "address",
                span: 24,
                rules: [{ required: true, message: "请输入公司地址" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "打印机标识",
                fieldName: "snCode",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "企业状态",
                fieldName: "status",
                span: 24,
                valuePropName: "checked",
                checkedChildren: "启用",
                unCheckedChildren: "禁用"
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "门店类型",
                fieldName: "type",
                span: 24,
                valuePropName: "checked",
                checkedChildren: "主",
                unCheckedChildren: "分"
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构名称",
                fieldName: "orgName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店类型名称",
                fieldName: "categoryName",
                hidden: true
            },
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `门店${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: debounce(() => { onSubmit() }, 900)
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
